


























import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component
export default class Layout extends Vue {
  @Prop(Number) value!: number
  @Prop(Array) readonly columns!: any

  // __DATA
  private currentValue: number = this.value
  private open: boolean = false

  // __MOUNTED
  public mounted () {
    document.addEventListener('click', this.closed, false)
  }

  // __METHODS
  private select (param: number): void {
    this.currentValue = param as number
    this.open = false
  }

  private closed (e: any): void {
    if (!this.$el.contains(e.target)) {
      this.open = false
    }
  }
  // __WATCH
  @Watch('currentValue')
  private onValueChange (val: number): void {
    this.$emit('input', val)
  }
}
